import React, { useEffect, useState } from "react";
import LayersIcon from '@mui/icons-material/Layers';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import HealingIcon from '@mui/icons-material/Healing';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';

const QuejasSection = ({
  quejasRecords,
  granelRecords,
  isFormOpen,
  setIsFormOpen,
  formData,
  setFormData,
  handleSaveQueja
}) => {
  const [selectedRecord, setSelectedRecord] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Auto-fill from bulk records if available
  useEffect(() => {
    if (formData.noLote && formData.noLote !== "manual") {
      const selected = granelRecords.find(r => r.noLote === formData.noLote);
      if (selected) {
        setFormData(prev => ({
          ...prev,
          descripcionProducto: `${selected.categoria} - ${selected.clase} (${selected.tipoMaguey})`
        }));
      }
    }
  }, [formData.noLote, granelRecords, setFormData]);

  const handleEditRecord = (rec) => {
    if (rec.status !== "borrador") {
      alert("Solo se pueden editar registros que se encuentren en estado BORRADOR.");
      return;
    }
    setFormData({
      fechaQueja: rec.fechaQueja || "",
      noQueja: rec.noQueja || "",
      noLote: rec.noLote || "manual",
      descripcionProducto: rec.descripcionProducto || "",
      detalleQueja: rec.detalleQueja || "",
      fechaAtencion: rec.fechaAtencion || "",
      medidasCorrectivas: rec.medidasCorrectivas || ""
    });
    setIsFormOpen(true);
  };

  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header">
          <h2>Quejas Acerca del Producto Certificado (Sección IX)</h2>
          <button 
            onClick={() => setIsFormOpen(true)}
            className="btn-add-new"
          >
            <AddIcon style={{ fontSize: 18 }} />
            <span>Registrar Nueva Queja</span>
          </button>
        </div>

        <div className="records-list-wrapper">
          <table className="records-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Fecha Queja</th>
                <th>Nº de Queja</th>
                <th>Nº de Lote</th>
                <th>Descripción del Producto</th>
                <th>Detalle de la Queja</th>
                <th>Fecha Atención</th>
                <th>Medidas Correctivas Implementadas</th>
                <th>V.Bo. Inspector</th>
                <th>Estado</th>
                <th style={{ textAlign: "center" }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {quejasRecords.map((rec, i) => (
                <tr key={i}>
                  <td>{rec.id}</td>
                  <td>{rec.fechaQueja}</td>
                  <td style={{ fontWeight: 800 }}>{rec.noQueja}</td>
                  <td style={{ color: "var(--copper)", fontWeight: 700 }}>{rec.noLote}</td>
                  <td>{rec.descripcionProducto}</td>
                  <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={rec.detalleQueja}>
                    {rec.detalleQueja}
                  </td>
                  <td>{rec.fechaAtencion || "-"}</td>
                  <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={rec.medidasCorrectivas}>
                    {rec.medidasCorrectivas || "-"}
                  </td>
                  <td style={{ fontSize: "11px" }}>{rec.inspector}</td>
                  <td>
                    <span className={`badge-status ${rec.status}`}>
                      {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                    </span>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <div style={{ display: "flex", justifyContent: "center", gap: "6px" }}>
                      <button 
                        type="button" 
                        onClick={() => setSelectedRecord(rec)}
                        title="Ver Detalle Completo"
                        style={{ background: "rgba(52, 152, 219, 0.15)", color: "#3498db", border: "1px solid rgba(52, 152, 219, 0.3)", borderRadius: "6px", padding: "5px 8px", cursor: "pointer", display: "flex", alignItems: "center" }}
                      >
                        <VisibilityIcon style={{ fontSize: 16 }} />
                      </button>

                      <button 
                        type="button" 
                        onClick={() => handleEditRecord(rec)}
                        disabled={rec.status !== "borrador"}
                        title={rec.status === "borrador" ? "Editar Registro" : "Solo editables en estado Borrador"}
                        style={{ 
                          background: rec.status === "borrador" ? "rgba(241, 196, 15, 0.15)" : "rgba(255,255,255,0.04)", 
                          color: rec.status === "borrador" ? "#f1c40f" : "var(--text-muted)", 
                          border: rec.status === "borrador" ? "1px solid rgba(241, 196, 15, 0.3)" : "1px solid rgba(255,255,255,0.08)", 
                          borderRadius: "6px", 
                          padding: "5px 8px", 
                          cursor: rec.status === "borrador" ? "pointer" : "not-allowed", 
                          display: "flex", 
                          alignItems: "center",
                          opacity: rec.status === "borrador" ? 1 : 0.4
                        }}
                      >
                        <EditIcon style={{ fontSize: 16 }} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* MODAL DE DETALLE COMPLETO DE QUEJAS */}
        {selectedRecord && (
          <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 999, padding: "20px" }}>
            <div className="detail-card animate-fadeIn" style={{ maxWidth: "650px", width: "100%", maxHeight: "90vh", overflowY: "auto", background: "#161b22", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "12px", padding: "24px", position: "relative" }}>
              <button 
                onClick={() => setSelectedRecord(null)}
                style={{ position: "absolute", top: "16px", right: "16px", background: "transparent", border: "none", color: "var(--text-muted)", cursor: "pointer" }}
              >
                <CloseIcon />
              </button>

              <div style={{ borderBottom: "1px solid rgba(255,255,255,0.1)", paddingBottom: "12px", marginBottom: "16px" }}>
                <span className={`badge-status ${selectedRecord.status}`} style={{ float: "right", marginTop: "4px" }}>
                  {selectedRecord.status === "aprobado" ? "Aprobado" : selectedRecord.status === "revision" ? "En revisión" : "Borrador"}
                </span>
                <h3 style={{ margin: 0, color: "var(--copper)", fontSize: "20px" }}>Queja Nº: {selectedRecord.noQueja}</h3>
                <small style={{ color: "var(--text-muted)" }}>Registro de Quejas Acerca del Producto Certificado (Sección IX)</small>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", fontSize: "14px" }}>
                <div><strong>Fecha de Queja:</strong> {selectedRecord.fechaQueja}</div>
                <div><strong>Nº de Lote Afectado:</strong> {selectedRecord.noLote}</div>
                <div style={{ gridColumn: "1 / -1" }}><strong>Descripción del Producto:</strong> {selectedRecord.descripcionProducto}</div>
                <div><strong>Fecha de Atención:</strong> {selectedRecord.fechaAtencion || "Pendiente"}</div>
                <div><strong>Inspector:</strong> {selectedRecord.inspector}</div>
              </div>

              <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                <strong>Detalle de la Queja:</strong>
                <p style={{ margin: "6px 0 12px 0", color: "var(--text-muted)", fontSize: "13px" }}>{selectedRecord.detalleQueja || "Sin detalles."}</p>
                <strong>Medidas Correctivas Implementadas:</strong>
                <p style={{ margin: "6px 0 0 0", color: "var(--text-muted)", fontSize: "13px" }}>{selectedRecord.medidasCorrectivas || "Sin medidas registradas."}</p>
              </div>

              <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                {selectedRecord.status === "borrador" && (
                  <button 
                    onClick={() => {
                      const rec = selectedRecord;
                      setSelectedRecord(null);
                      handleEditRecord(rec);
                    }}
                    className="btn-add-new"
                    style={{ padding: "8px 16px", fontSize: "13px" }}
                  >
                    <EditIcon style={{ fontSize: 16 }} />
                    <span>Editar Registro</span>
                  </button>
                )}
                <button onClick={() => setSelectedRecord(null)} className="btn-secondary-custom" style={{ padding: "8px 16px" }}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2>Nueva Queja / Reclamación de Producto - Sección IX</h2>
      </div>

      <div className="cards-container-grid">
        {/* IDENTIFICACION */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <ReportProblemIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Detalles de la Queja</h2>
              <p>Fecha, folio e identificación del lote afectado</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="date" 
                value={fechaQueja} 
                onChange={e => setFechaQueja(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Fecha de Recepción</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={noQueja} 
                onChange={e => setNoQueja(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. QJ-2026-001"
              />
              <label className="custom-input-label">Nº de Queja</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <select 
                value={noLote} 
                onChange={e => setNoLote(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="manual">Ingreso Manual (Lote no listado)</option>
                {granelRecords.map((r, idx) => (
                  <option key={idx} value={r.noLote}>
                    {r.noLote} ({r.categoria})
                  </option>
                ))}
              </select>
              <label className="custom-input-label">Nº de Lote Afectado</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={descripcionProducto} 
                onChange={e => setDescripcionProducto(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Mezcal Artesanal Joven 750ml"
              />
              <label className="custom-input-label">Descripción del Producto</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea 
              value={detalleQueja} 
              onChange={e => setDetalleQueja(e.target.value)} 
              className="custom-input-field"
              style={{ height: "100px", resize: "none", padding: "14px" }}
              placeholder="Describa el motivo de la queja, desviación reportada, etc..."
            />
            <label className="custom-input-label">Detalle de la Queja</label>
          </div>
        </section>

        {/* ATENCION Y MEDIDAS CORRECTIVAS */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <HealingIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Atención y Acciones Correctivas</h2>
              <p>Seguimiento, fechas de respuesta y medidas implementadas</p>
            </div>
          </header>

          <div className="custom-input-group" style={{ marginBottom: 20 }}>
            <input 
              type="date" 
              value={fechaAtencion} 
              onChange={e => setFechaAtencion(e.target.value)} 
              className="custom-input-field"
            />
            <label className="custom-input-label">Fecha de Atención</label>
          </div>

          <div className="custom-input-group">
            <textarea 
              value={medidasCorrectivas} 
              onChange={e => setMedidasCorrectivas(e.target.value)} 
              className="custom-input-field"
              style={{ height: "140px", resize: "none", padding: "14px" }}
              placeholder="Describa las acciones correctivas aplicadas..."
            />
            <label className="custom-input-label">Medidas Correctivas Implementadas</label>
          </div>
        </section>
      </div>

      <div className="button-row">
        <button type="button" className="btn-secondary-custom" onClick={() => setIsFormOpen(false)}>Volver</button>
        <button 
          type="button" 
          className="btn-primary-custom" 
          onClick={() => handleSaveQueja("revision")}
        >
          <CheckCircleIcon style={{ fontSize: 16 }} />
          <span>Registrar Queja Sección IX</span>
        </button>
      </div>
    </div>
  );
};

export default QuejasSection;
